import React from 'react'
import { Link } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';
import MenuButton from '../components/common/MenuButton';

const Home = ({ visible, setVisible }) => {
    return (
        <>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-5 h-full'>
                <div className='bg-gray-100 dark:bg-gray-800 flex flex-col justify-center items-center h-full'>
                    <h1 className='font-bold text-sm uppercase text-slate-900 dark:text-white'>Hi there, I'M</h1>
                    <h1 className='font-bold text-3xl uppercase text-slate-900 dark:text-white mb-1'>Shubham Gupta</h1>
                    <div className='font-bold text-xl uppercase text-skin-base'>&nbsp;
                        <TypeAnimation
                            cursor={false}
                            sequence={[
                                'Full Stack Developer',
                                2000,
                                'UI Designer',
                                2000,
                            ]}
                            speed={60}
                            wrapper="span"
                            repeat={Infinity}
                        />
                    </div>
                </div>
                <Link to="/about">
                    <div className='bg-white dark:bg-gray-900 flex justify-center items-center h-full rounded-custom'>
                        <h1 className='font-bold text-4xl uppercase text-slate-900 dark:text-white hover:scale-125 delay-200 duration-500 ease-in-out'>About <span className='text-skin-base'>me</span></h1>
                    </div>
                </Link>
                <Link to="/skills">
                    <div className='bg-white dark:bg-gray-900 flex justify-center items-center h-full rounded-custom'>
                        <h1 className='font-bold text-4xl uppercase text-slate-900 dark:text-white hover:scale-125 delay-200 duration-500 ease-in-out'>My <span className='text-skin-base'>Skills</span></h1>
                    </div>
                </Link>
                <Link to="/work">
                    <div className='bg-white dark:bg-gray-900 flex justify-center items-center h-full rounded-custom'>
                        <h1 className='font-bold text-4xl uppercase text-slate-900 dark:text-white hover:scale-125 delay-200 duration-500 ease-in-out'>My <span className='text-skin-base'>Work</span></h1>
                    </div>
                </Link>
                <Link to="/service">
                    <div className='bg-white dark:bg-gray-900 flex justify-center items-center h-full rounded-custom'>
                        <h1 className='font-bold text-4xl uppercase text-slate-900 dark:text-white hover:scale-125 delay-200 duration-500 ease-in-out'>My <span className='text-skin-base'>Service</span></h1>
                    </div>
                </Link>
                <Link to="/contact">
                    <div className='bg-white dark:bg-gray-900 flex justify-center items-center h-full rounded-custom'>
                        <h1 className='font-bold text-4xl uppercase text-slate-900 dark:text-white hover:scale-125 delay-200 duration-500 ease-in-out'>Get in <span className='text-skin-base'>touch</span></h1>
                    </div>
                </Link>

            </div>
            {visible ? <MenuButton visible={visible} setVisible={setVisible} /> : ''}

        </>

    )
}

export default Home